import { ChangeType, TargetArea } from "../model";
import SubRowHistoryText from "./Components/SubRowHistoryText";
import MigrationCreated from "./Migration/MigrationCreated";
import MigrationUpdated from "./Migration/MigrationUpdated";
import MigrationDeleted from "./Migration/MigrationDeleted";
import ProductCreated from "./Product/ProductCreated";
import ProductUpdated from "./Product/ProductUpdated";
import ProductDeleted from "./Product/ProductDeleted";
import ProductLegacy from "./Product/ProductLegacy";
import LicenseDeleted from "./License/LicenseDeleted";
import { UserCreated, UserUpdated, UserDeleted, UserCreatedLegacy, UserUpdatedLegacy, UserDeletedLegacy } from "./User/HistoryUser";
import { getValueByKey } from "../helpers";
import { ProjectCreated } from "./Project/ProjectCreated";
import { ProjectUpdated } from "./Project/ProjectUpdated";
import { ProjectDeleted } from "./Project/ProjectDeleted";
import { ProjectCreatedLegacy, ProjectUpdatedLegacy } from "./Project/ProjectLegacy";
import LicenseTransaction from "./License/LicenseTransaction";
import LicenseCreated from "./License/LicenseCreated";
import { FeatureCreated } from "./Feature/FeatureCreated";
import { FeatureDeleted } from "./Feature/FeatureDeleted";
import { FeatureUpdated } from "./Feature/FeatureUpdated";
import { FeatureCreatedLegacy, FeatureDeletedLegacy } from "./Feature/FeatureLegacy";
import { HistoryAction } from "./HistoryActionModel";

export const parseAction = (action: string): any => {
    try {
        return JSON.parse(action);
    } catch (error) {
        return action;
    }
};

export function formatLogMessage(log: string): string {
    if (!log.includes("-&gt;")) return log;

    const [intro, paramsString] = log.split(": ", 2);

    if (!paramsString) return intro;

    const params = paramsString.split(/,\s*(?![^']*')/).map((param) => {
        const [key, change] = param.split(":").map((s) => s.trim());
        return `  - ${key}: ${change.replace("-&gt;", "→")}`;
    });

    return `${intro}:
  ${params.join("\n")}`;
}

// New routing: uses EntityType and ChangeType strings from the action JSON
export const getComponentForEntityTypeAndChangeType = (
    entityType: string,
    changeType: string,
    action: HistoryAction
): JSX.Element => {
    switch (entityType) {
        case "User":
            if (changeType === "Added") return <UserCreated action={action} />;
            if (changeType === "Modified") return <UserUpdated action={action} />;
            if (changeType === "Deleted") return <UserDeleted action={action} />;
            break;

        case "Product":
            if (changeType === "Added") return <ProductCreated action={action} />;
            if (changeType === "Modified") return <ProductUpdated action={action} />;
            if (changeType === "Deleted") return <ProductDeleted action={action} />;
            break;

        case "Project":
            if (changeType === "Added") return <ProjectCreated action={action} />;
            if (changeType === "Modified") return <ProjectUpdated action={action} />;
            if (changeType === "Deleted") return <ProjectDeleted action={action} />;
            break;

        case "License":
            if (changeType === "Added") return <LicenseCreated action={action} />;
            if (changeType === "Modified") return <LicenseTransaction action={action} />;
            if (changeType === "Deleted") return <LicenseDeleted action={action} />;
            break;

        case "Feature":
            if (changeType === "Added") return <FeatureCreated action={action} />;
            if (changeType === "Modified") return <FeatureUpdated action={action} />;
            if (changeType === "Deleted") return <FeatureDeleted action={action} />;
            break;

        default:
            return <SubRowHistoryText action={JSON.stringify(action)} />;
    }
    return <SubRowHistoryText action={JSON.stringify(action)} />;
};

// Legacy routing: kept for backward compatibility with old format (Migration, etc.)
export const getComponentForChangeTypeAndTargetArea = (
    changeType: ChangeType,
    targetArea: TargetArea,
    action: any
): JSX.Element => {
    console.log(
        `ChangeType: ${getValueByKey(ChangeType, changeType)}, TargetArea: ${getValueByKey(TargetArea, targetArea)}, Action: ${JSON.stringify(action, null, 2)}`
    );

    switch (targetArea) {
        case TargetArea.User:
            if (changeType === ChangeType.Created) return <UserCreatedLegacy action={action} />;
            if (changeType === ChangeType.Updated) return <UserUpdatedLegacy action={action} />;
            if (changeType === ChangeType.Deleted) return <UserDeletedLegacy action={action} />;
            break;
        case TargetArea.Product:
            return <ProductLegacy action={action} />;
        case TargetArea.Project:
            if (changeType === ChangeType.Created) return <ProjectCreatedLegacy action={action} />;
            if (changeType === ChangeType.Updated) return <ProjectUpdatedLegacy action={action} />;
            break;
        case TargetArea.Migration:
            if (changeType === ChangeType.Created) return <MigrationCreated action={action} />;
            if (changeType === ChangeType.Updated) return <MigrationUpdated action={action} />;
            if (changeType === ChangeType.Deleted) return <MigrationDeleted action={action} />;
            break;
        case TargetArea.Feature:
            if (changeType === ChangeType.Created) return <FeatureCreatedLegacy action={action} />;
            if (changeType === ChangeType.Deleted) return <FeatureDeletedLegacy action={action} />;
            break;
        default:
            return <SubRowHistoryText action={JSON.stringify(action)} />;
    }
    return <SubRowHistoryText action={JSON.stringify(action)} />;
};
